module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f6eb3bcc.png";